//#region src/loyalty_auth_entry_method.ts
let LoyaltyAuthEntryMethod = /* @__PURE__ */ function(LoyaltyAuthEntryMethod) {
	LoyaltyAuthEntryMethod["BarcodeScanned"] = "barcode-scanned";
	LoyaltyAuthEntryMethod["CardNumberManuallyEntered"] = "card-number-manually-entered";
	LoyaltyAuthEntryMethod["CardNumberProvidedExternally"] = "card-number-provided-externally";
	LoyaltyAuthEntryMethod["EmailManuallyEntered"] = "email-manually-entered";
	LoyaltyAuthEntryMethod["EmailAndPasswordManuallyEntered"] = "email-and-password-manually-entered";
	LoyaltyAuthEntryMethod["EmailAndPhoneNumberManuallyEntered"] = "email-and-phone-number-manually-entered";
	LoyaltyAuthEntryMethod["EmailAndPhoneNumberProvidedExternally"] = "email-and-phone-number-provided-externally";
	LoyaltyAuthEntryMethod["PhoneNumberManuallyEntered"] = "phone-number-manually-entered";
	LoyaltyAuthEntryMethod["PhoneNumberProvidedExternally"] = "phone-number-provided-externally";
	LoyaltyAuthEntryMethod["RedemptionCodeManuallyEntered"] = "redemption-code-manually-entered";
	LoyaltyAuthEntryMethod["UnknownManuallyEntered"] = "unknown-manually-entered";
	LoyaltyAuthEntryMethod["UsernameAndPasswordManuallyEntered"] = "username-and-password-manually-entered";
	return LoyaltyAuthEntryMethod;
}({});
//#endregion
export { LoyaltyAuthEntryMethod };

//# sourceMappingURL=loyalty_auth_entry_method.js.map